import React from 'react';
import { useBrokerDetailsStore } from '../../../../state/brokerDetailsStore';
import { BankAccountBox } from '@apply/components';
import { isMobileScreen } from '@apply/ui';

export const BankWireLast4Digits: React.FC = () => {
    const wireAccountLastFourDigits = useBrokerDetailsStore((s) => s.wireAccountLastFourDigits);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    const isMobile = isMobileScreen();

    return (
        <BankAccountBox
            value={wireAccountLastFourDigits ? wireAccountLastFourDigits : ''}
            label='Enter last 4 of bank account:'
            onChange={(v) => updateFields({ wireAccountLastFourDigits: v })}
            width={isMobile ? '100%' : '220px'}
            maxLength={4}
            required={false}
        />
    );
};
